import { render, staticRenderFns } from "./delete-group-document.vue?vue&type=template&id=78eb3d11&scoped=true&"
import script from "./delete-group-document.vue?vue&type=script&lang=js&"
export * from "./delete-group-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78eb3d11",
  null
  
)

export default component.exports